import { css } from "styled-components";

import { text } from "@ui/helpers";

import { Size } from "../Button.types";

export const getSize = (size: Size) => css`
  ${size === "large" &&
  css`
    --button-padding-h: 24px;
    --button-padding-v: 16px;
    --button-icon-size: 24px;

    ${text("semibold_18")}
  `}

  ${size === "medium" &&
  css`
    --button-padding-h: 18px;
    --button-padding-v: 12px;
    --button-icon-size: 24px;

    ${text("semibold_18")}
  `}

    ${size === "small" &&
  css`
    --button-padding-h: 16px;
    --button-padding-v: 8px;
    --button-icon-size: 20px;

    ${text("semibold_14")}
  `}
`;
